import * as Y from 'yjs';

const YJS_DOCUMENT_COMPAT_MIGRATION_ORIGIN = Symbol('document-compat-migration');

interface RunYjsDocumentCompatMigrationsParams {
  ydoc: Y.Doc;
  canWrite: boolean;
}

function migrateAssetUrlDomains(yAssetsData: Y.Map<Y.Map<unknown>>): void {
  if (import.meta.env.IS_SERVER_TEST) {
    console.log('AA->同步数据 测试环境忽略');
    return;
  }
  let replaceNum = 0;

  console.log('AA->同步数据 开始');
  const RES_FROM = "https://canvas.qianlu.cc/";
  const RES_TO = "https://res.qianlu.net/";
  yAssetsData.forEach((yAsset) => {
    if (!(yAsset instanceof Y.Map)) {
      return;
    }

    const keys = yAsset.keys();
    for (const field of keys) {
      const currentValue = yAsset.get(field);
      if (typeof currentValue === 'string' && currentValue.startsWith(RES_FROM)) {
        replaceNum++;
        const nextValue = `${RES_TO}${currentValue.slice(RES_FROM.length)}`;
        yAsset.set(field, nextValue);
      }
    }
  });
  console.log(`AA->同步数据 总共替换 ${replaceNum} 个`)
}


function convertCustomData(ydoc: Y.Doc): void {
  let count = 0;
  const yMap = ydoc.getMap<Y.Map<any>>('customNodeDatas');
  for (const [_nodeId, value] of yMap.entries()) {
    const op = value.get('op') as string;
    const data = value.get('op_data');
    if (data && op && data instanceof Y.Map) {
      const opdata = data.get(op) as Y.Map<any>;
      if (opdata && opdata instanceof Y.Map) {
        const model = opdata.get('model')
        if(typeof model == 'string') {
          if (['kling-3-pro', 'kling-3-std'].indexOf(model) != -1) {
            opdata.set('model', 'kling-o3');
            count++;
          } else if (['kling-v3-pro', 'kling-v3-std'].indexOf(model) != -1) {
            opdata.set('model', 'kling-v3');
            count++;
          }
        }
      }
    }
  }
  console.log(`AA->同步数据 模型 总共替换 ${count} 个`)
}

export function runYjsDocumentCompatMigrations({
  ydoc,
  canWrite,
}: RunYjsDocumentCompatMigrationsParams): void {
  if (!canWrite) {
    return;
  }
  const yAssetsData = ydoc.getMap<Y.Map<unknown>>('assetsData');
  ydoc.transact(() => {
    migrateAssetUrlDomains(yAssetsData);
    convertCustomData(ydoc);
  }, YJS_DOCUMENT_COMPAT_MIGRATION_ORIGIN);
}
